import { EmptyState } from "@/components/widgets";
import { TrendingDown, TrendingUp, Minus, ChevronRight, Lightbulb } from "lucide-react";
import { cn } from "@/lib/utils";
import { PanelCard } from "./primitives";

const TONE_ICON = {
  positive: { Icon: TrendingUp, cls: "text-[hsl(var(--status-green))]" },
  negative: { Icon: TrendingDown, cls: "text-[hsl(var(--cx-crimson))]" },
  neutral: { Icon: Minus, cls: "text-muted-foreground" },
};

/* Rules-based Trend Insights — every line is verifiable via its drilldown link */
export const TrendInsightsPanel = ({ data, navigate }) => {
  if (!data) return null;
  const items = data.insights || [];
  return (
    <PanelCard
      title={<span className="flex items-center gap-1.5"><Lightbulb size={15} className="text-[hsl(var(--cx-gold))]" />Trend Insights — this month vs last</span>}
      right={data.as_of_fmt && (
        <span className="text-[0.65rem] text-muted-foreground tabular whitespace-nowrap">as of {data.as_of_fmt}</span>
      )}
      testId="trend-insights-panel"
      className="col-span-2 lg:col-span-12 order-[3.5] lg:order-none">
      {items.length === 0 ? (
        <EmptyState title="No insights yet" />
      ) : (
        <div className="px-2 pb-2.5">
          {items.map((i, idx) => {
            const t = TONE_ICON[i.tone] || TONE_ICON.neutral;
            return (
              <button key={`${i.signal}-${idx}`}
                className="w-full flex items-center gap-2.5 px-3 py-2 rounded-md text-left hover:bg-[hsl(var(--cx-surface))] transition-colors group"
                data-testid={`trend-insight-${idx}`}
                onClick={() => navigate(i.link)}>
                <t.Icon size={16} className={cn("shrink-0", t.cls)} />
                <span className="text-sm flex-1">{i.text}</span>
                <ChevronRight size={14} className="shrink-0 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
              </button>
            );
          })}
        </div>
      )}
    </PanelCard>
  );
};
